import { formatApiDateRangeDisplay } from '#/utils/date';

/**
 * UI range DatePicker ↔ listQuery.filters（API：`transfer_date_from`／`transfer_date_to`）。
 */
export function readTransferDateRangeFilter(filters = {}) {
  const from = filters.transferDateFrom;
  const to = filters.transferDateTo;

  if (!from && !to) {
    return undefined;
  }

  return {
    from: from ?? '',
    to: to ?? from ?? '',
  };
}

export function applyTransferDateRangeToFilters(filters = {}, range) {
  const next = { ...filters };

  if (!range?.from && !range?.to) {
    delete next.transferDateFrom;
    delete next.transferDateTo;
    return next;
  }

  const from = range.from;
  const to = range.to || range.from;

  // TODO: 單日 API 契約未確認 — 起迄同日時是否僅送 transfer_date_from（勿猜新參數名）
  next.transferDateFrom = from || undefined;
  next.transferDateTo = to || undefined;

  return next;
}

export function resolveTransferDateFilterChipDisplay(_values, ctx = {}) {
  const display = formatApiDateRangeDisplay({
    from: ctx.filters?.transferDateFrom,
    to: ctx.filters?.transferDateTo,
  });

  return display ? [display] : [];
}
